export default __webpack_public_path__ + "static/media/wave-06.8fdbbb63.png";